import { useEffect, useRef, useState } from "react";
import { MapPin } from "lucide-react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { COUNTRIES } from "@/lib/countries";

export const CountryDatalist = () => (
  <datalist id="orec-countries">
    {COUNTRIES.map((c) => <option key={c} value={c} />)}
  </datalist>
);

export const LocationInput = ({ city, country, onChange, autoDetect = true, idPrefix = "loc" }) => {
  const [detected, setDetected] = useState(false);
  const tried = useRef(false);

  useEffect(() => {
    if (!autoDetect || tried.current || city || country) return;
    tried.current = true;
    api.get("/geo/detect").then((r) => {
      if (r.data.city || r.data.country) {
        onChange({ city: r.data.city || "", country: r.data.country || "" });
        setDetected(true);
      }
    }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div>
          <Label htmlFor={`${idPrefix}-city`} className="text-xs uppercase tracking-wider text-muted-foreground">City</Label>
          <Input id={`${idPrefix}-city`} data-testid={`${idPrefix}-city-input`} value={city} placeholder="e.g. Calgary"
            onChange={(e) => { onChange({ city: e.target.value, country }); setDetected(false); }} className="mt-2" />
        </div>
        <div>
          <Label htmlFor={`${idPrefix}-country`} className="text-xs uppercase tracking-wider text-muted-foreground">Country</Label>
          <Input id={`${idPrefix}-country`} data-testid={`${idPrefix}-country-input`} value={country} placeholder="e.g. Canada" list="orec-countries"
            onChange={(e) => { onChange({ city, country: e.target.value }); setDetected(false); }} className="mt-2" />
        </div>
      </div>
      <CountryDatalist />
      {detected && (
        <p className="flex items-center gap-1.5 text-xs text-muted-foreground mt-2" data-testid={`${idPrefix}-detected-hint`}>
          <MapPin size={11} /> Detected automatically — edit if it's not quite right.
        </p>
      )}
    </div>
  );
};
